import evaluations from './evaluations'
import list from './list'
import participation from './participation'
import view from './view'

export default {
    evaluations,
    list,
    participation,
    view
}
